export const GET_CONFIG = 'GET_CONFIG';
export const SET_CONFIG = 'SET_CONFIG';
export const GET_CARD_PAYMENT = 'GET_CARD_PAYMENT';
export const SET_CARD_PAYMENT = 'SET_CARD_PAYMENT';
